import { render, staticRenderFns } from "./AddChildrenCardLimit.vue?vue&type=template&id=8885da80&scoped=true&"
import script from "./AddChildrenCardLimit.vue?vue&type=script&lang=js&"
export * from "./AddChildrenCardLimit.vue?vue&type=script&lang=js&"
import style0 from "./AddChildrenCardLimit.vue?vue&type=style&index=0&id=8885da80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8885da80",
  null
  
)

export default component.exports